import type { ReactNode } from 'react'
import { Header } from './Header'
import { Footer } from './Footer'
import { BackToTop } from '../common/BackToTop'

export function Layout({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 pt-12 md:pt-16">
        {children}
      </main>
      <Footer />
      <BackToTop />
    </div>
  )
}
